import type { GapReason } from "@patent-studio/api-types";

/**
 * Why a position was not compared with a document, in the attorney's words.
 * Keyed by the served type rather than listed, so a reason added to the enum
 * fails to compile here instead of rendering as its wire value.
 */
export const GAP_REASON_LABELS: Record<GapReason, string> = {
  refused: "the model declined to compare it",
  timed_out: "the comparison timed out",
  failed: "the comparison failed",
  no_answer: "the model gave no answer",
  unverified: "the passages quoted could not be found in the document",
  no_record: "its text could not be found",
  too_large: "it is too long to compare in one pass",
  added_since_run: "added after the analysis ran",
};
